module.exports = {
  domain: {
    desktop: "4njbets.prd.use2.racing.fndlext.net",
    mobile: "4njbets.prd.use2.racing.fndlext.net",
    talentPicks: "4njbets.prd.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.us.betfair.com"
  },
  service_host: "service.4njbets.prd.use2.racing.fndlext.net",
  recaptchaID: "6LdrNBgqAAAAAKKs_ZP23RQvTYPkSFdZQ9KK_j6K",
  recaptchaIdNative: "6LfSQloqAAAAAFKuurdHLnObQ-r2CGo0TuuYdNq-"
};
